export type PasswordRuleId =
  | 'minLength'
  | 'number'
  | 'special'
  | 'upper'
  | 'lower';

export interface PasswordRuleState {
  id: PasswordRuleId;
  met: boolean;
}

const SPECIAL_CHAR_RE = /[!@#$%^&*(),.?":{}|<>]/;

export function getPasswordRuleStates(password: string): PasswordRuleState[] {
  return [
    { id: 'minLength', met: password.length >= 8 },
    { id: 'number', met: /[0-9]/.test(password) },
    { id: 'special', met: SPECIAL_CHAR_RE.test(password) },
    { id: 'upper', met: /[A-Z]/.test(password) },
    { id: 'lower', met: /[a-z]/.test(password) },
  ];
}

export function isPasswordValid(password: string): boolean {
  return getPasswordRuleStates(password).every(rule => rule.met);
}
